<template>
  <div data-app class="contact">    
    <h1 class="titulo">Área do cliente</h1>
    <div class="user">
      <img alt="user" src="../assets/ico-user-b.svg" width="40"><br>
      {{ userName }}<br>
      {{ user.email }}<br>
      {{ user.username }}<br>
      <span class="ver-mas" @click="$router.push('/datas')">ver mas</span>      
    </div>    
    <logout-menu></logout-menu>
    <div id="company-content" class="company-content">
      <h5>Selecione a empresa</h5>
      <select class="input-select" v-model="company" @change="selCompany()">
        <option value="3">Conectividade por satélite</option>
        <option value="2">Outros produtos</option>
      </select>
    </div>
    <div class="content">
      <div class="contact-info" v-for="(item, index) in services" :key="index">

          <div v-if="haveData(item.area, 'internet')">
            <div class="sec-tarifa" v-for="(item, index) in item.data"  :key="index">
              <div class="img"><img alt="user" src="../assets/ico-router-s.svg" width="45"/></div>
              <div class="tarifa">{{ item.area }}</div>  
              <div class="tarifa-area">{{ item.address.street }}, {{ item.address.city }}</div>

              <div class="des-corta">{{ item['short_description'] }}<br><span v-if="item['short_description'] !== item['service']">{{ item['service'] }}</span></div>
<!--              
              <div v-if="item['tokens'] != ''">
                <div class="tokens" v-for="(item, index) in item['tokens']" :key="index">
                  <div class="img"><img alt="user" src="../assets/ico-bono.svg" width="22"></div>
                  <div class="name">{{ item['name'] }}</div>                
                </div>
              </div>
-->              
<!--
              <div v-if="item['children'] != ''">
                <div class="children" v-for="(item, index) in item['children']" :key="index">
                  <div class="img">
                    <img v-if="haveData(item['area'], 'Internet')" alt="user" src="../assets/ico-router-s.svg" width="35">
                    <img v-if="haveData(item['area'],'Móvil') || haveData(item['area'],'Movil')" alt="user" src="../assets/ico-mobile-s.svg" width="35">
                    <img v-if="haveData(item['area'],'Voz')" alt="user" src="../assets/ico-fijo-s.svg" width="35">
                  </div>
                  <div class="description">{{ item['short_description'] }}</div>
                  <div class="service" v-if="item['short_description'] !== item['service']">{{ item['service'] }}</div>
                </div>
              </div>
-->              
            </div>
          </div>

          <div v-if="haveData(item.area, 'movil') && !haveData(item.area, 'internet')">
            <div class="sec-tarifa" v-for="(item, index) in item.data"  :key="index">
              <div class="img"><img alt="user" src="../assets/ico-mobile-s.svg" width="45"/></div>
              <div class="tarifa">{{ item.area }}</div>
              <div class="tarifa-area">{{ item.phonenumber_mobile }}</div>

              <div class="des-corta">{{ item['short_description'] }}<br><span v-if="item['short_description'] !== item['service']">{{ item['service'] }}</span></div>
<!--
              <div v-if="item['tokens'] != ''">
                <div class="tokens" v-for="(item, index) in item['tokens']" :key="index">
                  <div class="img"><img alt="user" src="../assets/ico-bono.svg" width="22"></div>
                  <div class="name">{{ item['name'] }}</div>                
                </div>
              </div>
-->
<!--              
              <div v-if="item['children'] != ''">              
                <div class="children" v-for="(item, index) in item['children']" :key="index">
                  <div class="img">
                    <img v-if="haveData(item['area'], 'Internet')" alt="user" src="../assets/ico-router-s.svg" width="35">
                    <img v-if="haveData(item['area'],'Móvil') || haveData(item['area'],'Movil')" alt="user" src="../assets/ico-mobile-s.svg" width="35">
                    <img v-if="haveData(item['area'],'Voz')" alt="user" src="../assets/ico-fijo-s.svg" width="35">
                  </div>
                  <div class="description">{{ item['short_description'] }}</div>
                  <div class="service" v-if="item['short_description'] !== item['service']">{{ item['service'] }}</div>
                </div>
              </div>
-->              
            </div>
            <a class="te-interesa" href="https://eurona.es/static/images/821/comandos-movil.pdf" target="_blank">Te interesa</a>
          </div>  

          <div v-if="haveData(item.area, 'voz') && !haveData(item.area, 'internet') && !haveData(item.area, 'movil') ">
            <div class="sec-tarifa" v-for="(item, index) in item.data"  :key="index">
              <div class="img"><img alt="user" src="../assets/ico-fijo-s.svg" width="45"/></div>
              <div class="tarifa">{{ item.area }}</div>
              <div class="tarifa-area">{{ item.phonenumber_fix }}</div>

              <div class="des-corta">{{ item['short_description'] }}<br><span v-if="item['short_description'] !== item['service']">{{ item['service'] }}</span></div>
<!--
              <div v-if="item['tokens'] != ''">
                <div class="tokens" v-for="(item, index) in item['tokens']" :key="index">
                  <div class="img"><img alt="user" src="../assets/ico-bono.svg" width="22"></div>
                  <div class="name">{{ item['name'] }}</div>                
                </div>
              </div>
-->
<!--              
              <div v-if="item['children'] != ''">              
                <div class="children" v-for="(item, index) in item['children']" :key="index">
                  <div class="img">
                    <img v-if="haveData(item['area'], 'Internet')" alt="user" src="../assets/ico-router-s.svg" width="35">
                    <img v-if="haveData(item['area'],'Móvil') || haveData(item['area'],'Movil')" alt="user" src="../assets/ico-mobile-s.svg" width="35">
                    <img v-if="haveData(item['area'],'Voz')" alt="user" src="../assets/ico-fijo-s.svg" width="35">
                  </div>
                  <div class="description">{{ item['short_description'] }}</div>
                  <div class="service" v-if="item['short_description'] !== item['service']">{{ item['service'] }}</div>
                </div>
              </div>
-->              
            </div>            
          </div>                    
      </div>
      <div class="contact-info" style="margin-bottom: 122px;">
          <div class="facturas" @click="$router.push('/invoices')">Faturas</div>
          <div class="actualizar" @click="dialog_actualizar=true">Atualizar</div>

          <div class="boton-servicio" @click="dialog_servicio=true">
            <img src="../assets/ico-nuevo-servicio-w.svg" width="25"/>
            Novo<br>Serviço
          </div>
          <div class="boton-cliente" @click="dialog_cliente=true">
            <img src="../assets/ico-ventajas-w.svg" width="25"/>
            Benefícios<br>do cliente
          </div>
      </div>        
<!--
      <div class="contact-info promocion">
        <b>Valida tus datos de contacto y<br> participa en el sorteo para<br> conseguir uno de estos premios:</b>
        <div style="margin: 15px">
        - Tablet Samsung Tab A7<br>
        - Smartphone Galaxy A12<br>
        - Google ChromeCast 
        </div>     
      </div>       
      <div class="contact-info legal">
        <a href="https://eurona.es/bases-legales-sorteos" target="_blanck">Bases Legales del Sorteo ></a>
      </div>
      <div class="contact-info">
        <div class="boton-mis-datos" @click="$router.push('/datas')">Ir a Mis Datos ></div>
      </div>
-->
<!--
      <div class="contact-info promocion">
        <a href="https://www.eurona.es/amigo-eurona" target="_blanck"><img src="img/banner_eurona_azul.png" width="100%"></a>
      </div>  
-->
      <v-dialog v-model="dialog_actualizar" width="250">
        <v-card>
          <v-card-text>
            <div class="dialog-text-padding">
              <b>Atualizar os teus dados</b><br>
              <ul>
                <li><a href='https://eurona.pt/static/images/63/ALTERA%C3%87AO-DE-TITULAR-SATELITE.pdf' target="_blank">Alteração de titular</a></li>
                <li><a href='https://eurona.pt/static/images/63/Formulario-Altera%C3%A7ao-Domiciliacion-Bancaria.pdf' target="_blank">Alteração da conta bancária</a></li>
              </ul>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-btn color="blue-grey" block @click="dialog_actualizar=false">Fechar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>  

      <v-dialog v-model="dialog_servicio" width="550">
        <v-card>
          <v-card-text>
            <div class="dialog-text-padding">
              <span class="resaltado">Novo Serviço</span><br><br>  
              Contrata outro serviço de internet Satélite para ti e recomenda-nos a um amigo e ganha um vale para gastar na Amazon
Podes ganhar até <span class="resaltado">180€</span>!!!<br><br>
Informa-te das nossas tarifas em <a href='https://www.eurona.pt'>www.eurona.pt</a><br><br>
Lembra-te que podes ter tantos Satélites quanto necessites
            </div>
          </v-card-text>
          <v-card-actions>
            <v-btn color="blue-grey" block @click="dialog_servicio=false">Fechar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>  

      <v-dialog v-model="dialog_cliente" width="550">
        <v-card>
          <v-card-text>
            <div class="dialog-text-padding">       
              <span class="resaltado">Benefícios do cliente</span><br><br>
              Consegue até <span class="resaltado">180€</span> para gastar na Amazon se os teus amigos ou familiares contratarem a Eurona.
            </div>
          </v-card-text>
          <v-card-actions>
            <v-btn color="blue-grey" block @click="dialog_cliente=false">Fechar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>  
    </div>
  </div>
</template>

<script>
import LogoutMenu from '../components/LogoutMenu.vue'
import { mapGetters } from 'vuex'
export default {
  name: 'Invoive',
  data () {
    return {
      services: [],
      company: 0,
      domain: true,
      dialog_actualizar: false,
      dialog_servicio: false,
      dialog_cliente: false      
    }
  },
  mounted () {
    if (!this.logged) {
      this.$router.push("/")
    } else {
      this.getServices()
    }
  },  
  methods: {
    haveData (element, valor) {
      if (element !== undefined) if (element.includes(valor)) return true
      return false
    },
    getServices () {
      this.$http.get('/api/customer_services').then(response => {
        if(response.data['result'] == 'ok') {
          this.services = []
          
          if (response.data['company'] != 0){
            // mostramos selector si hay mas de una compañia
            this.company = response.data['company']
            document.getElementById('company-content').classList.add("show")
          }

          // creamos estructura
          for (let i = 0; response.data['data'].length > i; i++) {
            let area = this.slugify(response.data['data'][i].area)
            let existe = false
            for (let j = 0; this.services.length > j; j++) {
              if (this.services[j].area == area) {
                this.services[j].data.push(response.data['data'][i])
                existe = true
                break
              }
            }
            if (existe == false) {
              this.services.push({
                area: area,
                name: response.data['data'][i].area,
                data: [response.data['data'][i]]
              })
            }
          }          
        }
      }).catch((e) => {
        this.$store.commit('logout')
        this.$router.push("/")   
        console.log(e)
      })      
    },
    selCompany () {
      let payload = {
        company: this.company
      }      
      this.$http.post('/api/set_token', payload).then(response => {
        if(response.data['result'] == 'ok') {
          this.getServices()
        }                
      }).catch((e) => {
        console.log(e)
      })  
    },     
    slugify (str) {
      return str
          .toString()
          .normalize('NFD')                   // split an accented letter in the base letter and the acent
          .replace(/[\u0300-\u036f]/g, '')   // remove all previously split accents
          .toLowerCase()
          .trim()
          .replace(/[^a-z0-9 ]/g, '')   // remove all chars not letters, numbers and spaces (to be replaced)
          .replace(/\s+/g, '')
    }
  },
  computed: {
    ...mapGetters(['logged','userName', 'user'])
  },  
  components: { LogoutMenu }
}
</script>

<style>
.user {
  font-size: 14px;
  color: var(--azul-2);
  text-align: center;
}

.ver-mas {
  cursor: pointer;
  color: var(--gris-2);
  text-decoration: underline;
}

.company-content {
    padding-bottom: 0;
}

.contact .content {
  margin-bottom: 80px;
}

.contact-info {
  margin: 0 auto;
  width: 33%;
}

.contact-info .sec-tarifa {
  padding: 0 0 15px 0;
}

.contact-info .img {
  float: left;
  width: 20%;
  height: 45px;
}

.contact-info .tarifa {
  float: left;
  font-size: 18px;
  font-weight: bold;
  width: 80%;
  padding: 15px 0 0 0;
}

.contact-info .tarifa-area {
    clear: both;
    padding: 10px 0 0 0;
    font-size: 12px;
    color: var(--gris-1);
    font-weight: bold;
    font-style: italic;
}

.contact-info .des-corta {
  clear: both;
  font-size: 14px;
  padding: 10px 0;
}

.contact-info .children {
  padding: 0 0 0 15px;
  font-size: 13px;
}

.contact-info .children .img {
  float: left;
  width: 10%;
  height: 35px;
}

.contact-info .children .description {
  float: left;
  width: 80%;
  font-size: 13px;
  padding: 10px 0 8px 0;
  font-weight: 500;  
}

.contact-info .children .service {
  font-size: 13px;
  padding: 0 0 10px 30px;
}

.contact-info .tokens {
  padding: 0 0 0 18px;
  font-size: 13px;
  height: 40px;
}

.contact-info .tokens .img {
  float: left;
  width: 10%;
  height: 35px;
  text-align: center;
  padding-top: 5px;  
}

.contact-info .tokens .name {
  float: left;
  width: 90%;
  font-size: 13px;
  height: 25px;
  padding: 10px 0 0 0;
  font-weight: 500;  
}

.boton-mis-datos {
  margin: 15px auto;
  padding: 10px;
  color: var(--blanco);
  background-color: var(--fucsia-1);
  font-size: 20px;
  width: 200px;
  border-radius: 4px 4px 4px 4px;
    -moz-border-radius: 4px 4px 4px 4px;
    -webkit-border-radius: 4px 4px 4px 4px;
  cursor: pointer;
  text-align: center;
}

.te-interesa {
  color: var(--fucsia-1);
  font-size: 15px;
  cursor: pointer;
  text-decoration: none;
}

.contact .boton-servicio {
  position: relative;
  clear: both;
  float: left;
  margin: 15px auto;
  padding: 10px 0 10px 15px;
  color: var(--blanco);
  background-color: var(--azul-1);
  font-size: 15px;
  width: 140px;
  cursor: pointer;
  text-align: center;
  box-shadow: 2px 2px 2px 1px rgba(0, 0, 0, 0.5);
}

.contact .boton-cliente {
  position: relative;
  float: right;
  margin: 15px auto;
  padding: 10px 0 10px 30px;
  color: var(--blanco);
  background-color: var(--fucsia-1);
  font-size: 15px;
  width: 145px;
  cursor: pointer;
  text-align: center;
  box-shadow: 2px 2px 2px 1px rgba(0, 0, 0, 0.5);
}

.boton-servicio img {
  position: absolute;
  top: 15px;
  left: 20px;
}

.boton-cliente img {
  position: absolute;
  top: 17px;
  left: 20px;
}

.resaltado {
  font-weight: bold;
  color: var(--azul-2);
}

.promocion {
  clear: both;
  width: 35%;
  padding: 15px;
  color: var(--blanco);
  background-color: var(--azul-2);
  font-size: 18px;
}

.promocion a {
  color: var(--blanco);
  font-size: 15px;
}

.logo-amazon {
    float: left;
    text-indent: -500px;
    background-position: -10px -51px;
    width: 97px;
    height: 30px;
    background-image: url(https://images-eu.ssl-images-amazon.com/images/G/30/gno/sprites/nav-sprite-global-1x-hm-dsk-reorg._CB405936353_.png);
}

.legal {
  width: 35%;  
  padding: 15px 0 15px 0;
  color: var(--gris-2);
  font-size: 12px;
  text-align: right;
}

.legal a, .legal a:visited {
  color: var(--gris-3);
}

.legal a:hover {
  color: var(--fucsia-1);
}

.facturas {
  float: left;
  margin: 15px 0;
  color: var(--azul-2);
  cursor: pointer;
}

.actualizar {
  float:right;
  margin: 15px 0;
  color: var(--azul-2);
  cursor: pointer;
}

ul {
  margin: 0 0 0 15px;
}

.link {
  color: var(--azul-2);
  cursor: pointer;
}

@media (max-width: 768px) {
  .contact-info {
    width: 90%;
  }

  .input-select {
    width: 85%!important;
  }  

  h5 {
    clear: both;
    margin-top: 40px;
    text-align: left!important;
    width: 85%!important;  
  }  

  .boton-servicio, .boton-cliente {
    width: 125px;
  }
}

</style>